import { UserDetail } from 'model/business-base';
import { ApprovalLevel } from 'model/business-keywords';
import { EntityBase } from 'model/platform-types';
import { ApproveType, CountryApprovalRequirement } from './swagger/ApiClient';

export abstract class GeneralCountriesApi {
  abstract getCountrySettings(): Promise<CountrySettings[]>;
  abstract getTravelQuestions(): Promise<TravelQuestion[]>;
}

export interface CountrySettings extends EntityBase {
  conditionMessage: string | null;
  approvalLevel: ApprovalLevel;
  approvalRequirementValue: CountryApprovalRequirement;
  approvalTypeValue: ApproveType;
  approvers: UserDetail[];
  questionIds: number[];
}

export interface TravelQuestion extends EntityBase {
  message: string;
  global: boolean;
  mandatory: boolean;
  defaultChecked: boolean;
}
